/**
 * Anuncios de actualización, uno por versión.
 * La última entrada de la lista es la vigente.
 * Una versión nueva se agrega al final y vuelve a mostrarse aunque la anterior ya esté vista.
 *
 * Clave de esta versión:
 * app_release_announcement_firma_guiada_notas_v2_2026_10:<userId>
 * Valor:
 * release-announcement-firma-guiada-notas-v2-2026-10
 *
 * En desarrollo, la consola del navegador puede reiniciar la marca del usuario actual:
 * __reiniciarAnuncioActualizacion()
 * Ese helper no se instala fuera del entorno de desarrollo.
 */
import { usuarioEnSesionId } from './newsTours'

export const ANUNCIOS_DE_VERSION = [
  {
    id: 'release-announcement-firma-guiada-notas-v2-2026-10',
    version: 'release-announcement-firma-guiada-notas-v2-2026-10',
    storageKeyPrefix: 'app_release_announcement_firma_guiada_notas_v2_2026_10',
    tourId: 'firma-guiada-notas-v2-2026-10',
    bloqueoSegundos: 15,
    titulo: 'PDFSigner evoluciona',
    subtitulo:
      'Nuevas herramientas para preparar, revisar y firmar documentos con mayor precisión y trazabilidad.',
    novedades: [
      {
        id: 'campos',
        titulo: 'Campos de firma',
        texto: 'Define exactamente dónde debe firmar cada participante.',
      },
      {
        id: 'guiada',
        titulo: 'Firma guiada',
        texto: 'Cada firmante ve su espacio asignado y la firma se coloca automáticamente en la posición definida.',
      },
      {
        id: 'notas',
        titulo: 'Observaciones y notas',
        texto: 'Agrega notas trazables con autor, fecha y posición. Las observaciones acompañan el documento durante todo el proceso.',
      },
      {
        id: 'visualizar',
        titulo: 'Visualizar antes de firmar',
        texto: 'Revisa el documento, sus notas y campos antes de firmar o rechazar.',
      },
      {
        id: 'calidad',
        titulo: 'Mejoras de firma',
        texto: 'Mejoramos la posición y calidad de las firmas libres y de imagen.',
      },
      {
        id: 'historial',
        titulo: 'Historial y navegación',
        texto: 'Consultar, buscar y navegar documentos es ahora más rápido.',
      },
    ],
  },
]

export function anuncioVigente() {
  return ANUNCIOS_DE_VERSION[ANUNCIOS_DE_VERSION.length - 1] || null
}

export function claveAnuncio(anuncio, userId) {
  return `${anuncio.storageKeyPrefix}:${userId}`
}

export function anuncioPendientePara(userId) {
  const anuncio = anuncioVigente()
  if (!anuncio || userId == null || userId === '') return null
  try {
    const marca = localStorage.getItem(claveAnuncio(anuncio, userId))
    if (marca === String(anuncio.version)) return null
  } catch {
    return null
  }
  return anuncio
}

export function marcarAnuncioVisto(anuncio, userId) {
  if (!anuncio || userId == null || userId === '') return
  try {
    localStorage.setItem(claveAnuncio(anuncio, userId), String(anuncio.version))
  } catch {
    /* ignore */
  }
}

export function esEntornoDePruebaAnuncio() {
  if (import.meta.env.DEV) return true
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') return true
  const api = String(import.meta.env.VITE_API_URL || '')
  return api.includes(':8001')
}

export function reiniciarAnuncioActualizacion(userId) {
  const id = userId == null || userId === '' ? usuarioEnSesionId() : String(userId)
  const anuncio = anuncioVigente()
  if (!anuncio || !id) return null
  const clave = claveAnuncio(anuncio, id)
  try {
    localStorage.removeItem(clave)
  } catch {
    /* ignore */
  }
  return clave
}

export function instalarAyudaDesarrolloAnuncio() {
  if (!esEntornoDePruebaAnuncio() || typeof window === 'undefined') return
  window.__reiniciarAnuncioActualizacion = reiniciarAnuncioActualizacion
}
